import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Toaster as Sonner, toast } from 'sonner';
const toastClassName = 'group toast redesign group-[.toaster]:rounded-xl group-[.toaster]:border-border '
    + 'group-[.toaster]:bg-popover group-[.toaster]:text-foreground group-[.toaster]:shadow-lg';
// Error toast: dark red surface with light red text, for clear (but not neon) error signalling.
const errorToastClassName = 'group-[.toaster]:border-red-800/60 group-[.toaster]:bg-red-950 group-[.toaster]:text-red-100 '
    + '[&_[data-description]]:text-red-200/80 [&_[data-icon]]:text-red-300';
/**
 * Redesign toast surface. Mount a single <Toaster /> at the app root and fire toasts
 * with the re-exported `toast`. Styled with the redesign tokens; the app is dark.
 */
export const Toaster = (props) => {
    // Sonner v2 renders its container in place (no internal portal), so when a page mounts <Toaster />
    // inside its layout it inherits that stacking context and gets trapped BELOW the redesign modal,
    // which portals to document.body at z-index ~1100. Portal the toaster to document.body too so its
    // own high z-index wins and toasts sit above the modal. Guarded so SSR and first paint render null.
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, []);
    const toaster = (<Sonner theme="dark" className="toaster group redesign" toastOptions={{
            classNames: {
                toast: toastClassName,
                description: 'group-[.toast]:text-muted-foreground',
                actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
                cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
                error: errorToastClassName,
            },
        }} {...props}/>);
    if (!mounted) {
        return null;
    }
    return createPortal(toaster, document.body);
};
export { toast };
